/** GeoJSON Point — coordinates are [longitude, latitude] */
export class GeoJsonPoint {
  type: 'Point' = 'Point';
  coordinates: [number, number]; // [lon, lat]
}

export class ReportConfig {
  customTemplate?: string;
  templateMaturityMeasurement?: string;
  templateTemperatureMeasurement?: string;
  templateQualityControlReport?: string;
}

export class ProjectElementSetRules {
  controlMethodId?: string;
  baseElementType?: string;
  maxBatchVolume?: number;
  maxBatchTimeWeeks?: number;
  elementSpecificCriteria?: any;
  samplingRate?: number;
  minSamplesPerBatch?: number;
  acceptanceParameters?: any;
}

export class ProjectElementSet {
  id?: string;
  label?: string;
  baseElementType?: string;
  controlMethodId?: string;
  rules?: ProjectElementSetRules;
  /**
   * Short prefix for lot codes within this element set (e.g. 'CIM', 'M', 'PIL').
   * Auto-derived from first 3 alphabetic chars of label at creation. User-overridable.
   * Must be unique across all element sets in the project.
   */
  lotCodePrefix?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export class ProjectQualityConfig {
  standardId?: string;
  elementSets?: ProjectElementSet[];
  useConcreteCertification?: boolean;
  configuredAt?: Date;
  configuredBy?: string;
}

export class ProjectAnalyticsInboundEmailConfig {
  allowListEnabled?: boolean;
  allowList?: string[];
}

export class ProjectAnalyticsConfig {
  inboundEmailToken?: string | null;
  inboundEmail?: ProjectAnalyticsInboundEmailConfig;
}

export class ProjectMonitoringConfig {
  defaultMeasurementStarted?: boolean;
}

export class ProjectConfig {
  monitoringConfig?: ProjectMonitoringConfig;
}

export class InboundEmailAddresses {
  str: string;
  dn: string;
  generic: string;
}

export class Project {
  _id?: string;
  name?: string;
  description?: string;
  country?: string;
  owner?: string;
  company?: string;
  location?: GeoJsonPoint;
  addressShipping?: any[];
  addressInvoicing?: any;
  active?: boolean;
  shared_w?: string[];
  shared_r?: string[];
  data?: any;
  plano?: string;
  reportImage?: string;
  reportsEnabled?: boolean;
  reportsEmail?: string;
  files?: any[];
  updatedAt?: Date;
  createdAt?: Date;
  number_measurements?: number;
  visualizationConfig?: ProjectVisualizationConfig;
  notificationsConfig?: ProjectNotificationsConfig;
  reportConfig?: ReportConfig;
  metadata?: ProjectMetadata;
  modules?: ModulesConfig;
  qualityConfig?: ProjectQualityConfig;
  analyticsConfig?: ProjectAnalyticsConfig;
  config?: ProjectConfig;
}

export class ProjectVisualizationConfig {
  maturity: VisualizationConfig;
  maturityThreshold: VisualizationConfig;
  relativeMaturity: VisualizationConfig;
  relativeMaturityThreshold: VisualizationConfig;
}

class VisualizationConfig {
  app: boolean;
  report: boolean;
}

export class ProjectNotificationsConfig {
  emails: string[];
  channels: NotificationsChannels;
  variables: string[];
  requirements: object;
}

class NotificationsChannels {
  app: boolean;
  email: boolean;
}

class ProjectMetadata {
  projectCode: string;
  contractNumber: string;
  contractDate: Date;
}

class ModuleConfig {
  enabled: boolean;
  purchased: boolean;
}

class ModulesConfig {
  monitoring: ModuleConfig;
  analytics: ModuleConfig;
  simulations: ModuleConfig;
  qualityControl: ModuleConfig;
}

export interface SelfServeProjectResponse {
  project: Project;
  user: { _id: string; selfServeProjectId: string; [key: string]: any };
}
